import { httpsCallable } from "firebase/functions";
import { functions } from "../firebaseInit"; // firebaseInit’i kullanıyoruz
const addAuditLogFn = httpsCallable(functions, "addAuditLog");
const addSystemLogFn = httpsCallable(functions, "addSystemLog");

// 🔹 Audit Log: Kim, ne yaptı (CRUD, login, logout gibi)
async function addAuditLogClient(params: {
  action: string;
  entityType: string;
  entityId?: string;
  description?: string;
}) {
  try {
    const res = await addAuditLogFn(params);
    return res.data;
  } catch (err) {
    console.error("Audit log Cloud Function call failed:", err);
  }
}

// 🔹 System Log: Bilgi / hata / debug (teknik kayıtlar)
async function addSystemLogClient({
  level,
  message,
  context
}: {
  level: "info" | "error" | "warn" | "debug";
  message: string;
  context?: any;
}) {
  try {
    const res = await addSystemLogFn({ level, message, context });
    return res.data;
  } catch (err) {
    console.error("System log Cloud Function call failed:", err);
  }
}

// ✔ Helper: hızlıca error log ekleme
async function addErrorLog(message: string, error?: any, extraContext?: any) {
  await addSystemLogClient({
    level: "error",
    message,
    context: {
      errorMessage: error?.message,
      stack: error?.stack,
      ...extraContext
    }
  });
}

async function addInfoLog(message: string, extraContext?: any) {
  await addSystemLogClient({
    level: "info",
    message,
    context: extraContext || {}
  });
}

async function addWarnLog(message: string, extraContext?: any) {
  await addSystemLogClient({
    level: "warn",
    message,
    context: extraContext || {}
  });
}

// 🔹 Tek bir servis export et
const LogService = {
  addAuditLogClient,
  addErrorLog,
  addInfoLog,
  addWarnLog
};
export default LogService;
